import _get from 'lodash/get';
import _omit from 'lodash/omit';
import {
  Audience,
  CustomAttributes,
  Experiment,
  localStorageExperimentKey
} from './constants';

/**
 * updates localstorage representation of experiment for the user
 * @param experimentId experiment id
 * @param variationId derived variation id or null if user is not eligible
 */
export const updateActiveExperiments = (
  experimentId: string,
  variationId: string | null
) => {
  if (!experimentId) {
    return;
  }

  let existingExperiments = JSON.parse(
    localStorage.getItem(localStorageExperimentKey) as string
  );

  if (!existingExperiments) {
    existingExperiments = {};
  }

  let updatedExperiments;
  if (variationId) {
    updatedExperiments = Object.assign({}, existingExperiments, {
      [experimentId]: variationId
    });
  } else {
    // if variationId is null, the user should not be in the experiment
    updatedExperiments = _omit(existingExperiments, [experimentId]);
  }

  // set new active experiments for the current user
  localStorage.setItem(
    localStorageExperimentKey,
    JSON.stringify(updatedExperiments)
  );
};

/**
 * - determines which experiments and variations should be shown to the user
 * - sets active experiments in localStorage
 * @param cstmAttrs custom attributes for determining experiment eligibility
 * @param inputExperiment experiment that we are trying to bucket the user into
 */
export const bucketUser = (
  cstmAttrs: CustomAttributes,
  inputExperiment: Experiment
): void => {
  if (
    !cstmAttrs ||
    !cstmAttrs.experimentToken ||
    !inputExperiment ||
    !inputExperiment.id
  ) {
    return;
  }

  const { experimentToken } = cstmAttrs;

  const userIsEligible = inputExperiment.audiences.every((aud: Audience) => {
    return aud.isMember(cstmAttrs);
  });

  const derivedVariationId = userIsEligible
    ? inputExperiment.bucket(experimentToken, inputExperiment.id)
    : null;

  updateActiveExperiments(inputExperiment.id, derivedVariationId);
};

export default {
  bucketUser
};
